/* GB: Tooltip. Drives every .gb-tip button (snippets/gb-tooltip.liquid).
   One shared box at the end of <body>, so no carousel, card or animated
   (transformed) parent can clip or shift it.
   - Mouse: shows on hover, hides on leave.
   - Keyboard: shows on focus, hides on blur or Escape.
   - Touch and click: a tap opens it and keeps it open; tap the "?" again,
     tap anywhere else or press Escape to close. One box at a time.
   - Inside a card that is a link, a tap on the "?" never follows the link.
   - Follows the "?" while the page or a carousel scrolls, and closes when
     the "?" leaves the screen.
   Event delegation on document, so blocks added later (theme editor,
   filtering, tabs) work with no setup. Loaded twice? Runs once. */
(function () {
  if (window.gbTooltip) return;

  const EDGE = 16; // px kept clear of the screen edges
  const GAP = 8; // px between the "?" and the box
  let box = null;
  let active = null;
  let pinned = false;
  let frame = 0;

  function getBox() {
    if (!box) {
      box = document.createElement('div');
      box.className = 'gb-tip-box';
      box.setAttribute('aria-hidden', 'true');
      document.body.appendChild(box);
    }
    return box;
  }

  function place() {
    frame = 0;
    if (!active) return;
    const trigger = active.getBoundingClientRect();
    const viewHeight = window.innerHeight;
    if (!active.isConnected || trigger.bottom < 0 || trigger.top > viewHeight) {
      close();
      return;
    }
    const viewWidth = document.documentElement.clientWidth;
    const size = box.getBoundingClientRect();
    const centre = trigger.left + trigger.width / 2;
    const left = Math.max(EDGE, Math.min(centre - size.width / 2, viewWidth - EDGE - size.width));
    let top = trigger.top - GAP - size.height;
    if (top < EDGE) top = trigger.bottom + GAP;
    box.style.left = `${Math.round(left)}px`;
    box.style.top = `${Math.round(top)}px`;
  }

  function schedule() {
    if (active && !frame) frame = requestAnimationFrame(place);
  }

  function open(trigger, pin) {
    if (active && active !== trigger) close();
    active = trigger;
    pinned = pin;
    const el = getBox();
    el.textContent = trigger.dataset.gbTip || '';
    trigger.setAttribute('aria-expanded', 'true');
    el.classList.add('is-open');
    place();
  }

  function close() {
    if (!active) return;
    active.setAttribute('aria-expanded', 'false');
    active = null;
    pinned = false;
    if (box) box.classList.remove('is-open');
  }

  const tipFrom = (target) => (target && target.closest ? target.closest('.gb-tip') : null);

  document.addEventListener('click', (event) => {
    const trigger = tipFrom(event.target);
    if (!trigger) return;
    // Never follow a card link around the "?".
    event.preventDefault();
    event.stopPropagation();
    if (active === trigger && pinned) close();
    else open(trigger, true);
  });

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const trigger = tipFrom(event.target);
    if (trigger && !pinned) open(trigger, false);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse' || pinned) return;
    const trigger = tipFrom(event.target);
    if (trigger && trigger === active && !trigger.contains(event.relatedTarget)) close();
  });

  document.addEventListener('pointerdown', (event) => {
    if (active && !tipFrom(event.target)) close();
  });

  document.addEventListener('focusin', (event) => {
    const trigger = tipFrom(event.target);
    if (trigger && trigger.matches(':focus-visible') && active !== trigger) open(trigger, false);
  });

  document.addEventListener('focusout', (event) => {
    if (active && event.target === active) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && active) close();
  });

  window.addEventListener('scroll', schedule, { capture: true, passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  window.gbTooltip = { open, close };
})();
